import React, { useEffect, useState } from "react";

import {
  IconButton,
  Snackbar,
  TextField,
  Button,
} from "@material-ui/core";

import { Card, Modal } from "react-bootstrap";
import { Row, Col } from "reactstrap";

import "./ModulesFabrication.css";

const FicheDoss = ({
  ConfigDossier,
  show = true,
  onHide = () => {},
}) => {

  const [loading, setLoading] = useState(false);

  const [snackbaropen, setsnackbaropen] =
    useState(false);

  const [snackbarmsg, setsnackbarmsg] =
    useState("");

  const [ctrlstk, setctrlstk] =
    useState("");

  const [GS, setGS] =
    useState("");

  const [SV, setSV] =
    useState("");

  const [GMM, setGMM] =
    useState("");

  const [GFTT, setGFTT] =
    useState("");

  const [GA, setGA] =
    useState("");

  const [
    AffCalculImport,
    setAffCalculImport,
  ] = useState("");

  const [GPV, setGPV] =
    useState("");

  const [fact_pv, setFact_pv] =
    useState("");

  const [GSAV, setGSAV] =
    useState("");

  const [MD, setMD] =
    useState("");

  // =========================
  // GET DATA
  // =========================

  useEffect(() => {

    if (!ConfigDossier) return;

    const fetchData = async () => {

      try {

        const response = await fetch(
          `https://www.24-crm.tn/webservice/api/Dossier?coddos=${ConfigDossier.coddos}&serveur=${ConfigDossier.serveur}&user=${ConfigDossier.utilisateur}&pwd=${ConfigDossier.pwd_serveur}&database=PSDOSSIER`
        );

        const data = await response.json();

        const dossier =
          Array.isArray(data)
            ? data[0]
            : data;

        if (dossier) {

          setctrlstk(
            dossier.ctrlstk || ""
          );

          setGS(
            dossier.GS || ""
          );

          setSV(
            dossier.SV || ""
          );

          setGMM(
            dossier.GMM || ""
          );

          setGFTT(
            dossier.GFTT || ""
          );

          setGA(
            dossier.GA || ""
          );

          setAffCalculImport(
            dossier.AffCalculImport || ""
          );

          setGPV(
            dossier.GPV || ""
          );

          setFact_pv(
            dossier.fact_pv || ""
          );

          setGSAV(
            dossier.GSAV || ""
          );

          setMD(
            dossier.MD || ""
          );
        }

      } catch (error) {

        console.error(error);

        setsnackbaropen(true);

        setsnackbarmsg(
          "Erreur chargement données"
        );
      }
    };

    fetchData();

  }, [ConfigDossier]);

  // =========================
  // SAVE
  // =========================

  const enregistrer = async () => {

    if (!ConfigDossier) return;

    setLoading(true);

    const requestBody = {

      ctrlstk,

      GS,

      SV,

      GMM,

      GFTT,

      GA,

      AffCalculImport,

      GPV,

      fact_pv,

      GSAV,

      MD,
    };

    try {

      const response = await fetch(
        `https://www.24-crm.tn/webservice/api/Dossier?coddos=${ConfigDossier.coddos}&serveur=${ConfigDossier.serveur}&user=${ConfigDossier.utilisateur}&pwd=${ConfigDossier.pwd_serveur}&database=${ConfigDossier.database}`,
        {
          method: "PUT",

          headers: {
            Accept: "application/json",
            "Content-Type":
              "application/json",
          },

          body: JSON.stringify(
            requestBody
          ),
        }
      );

      await response.json();

      setsnackbaropen(true);

      setsnackbarmsg(
        "Enregistré avec succès"
      );

    } catch (error) {

      console.error(error);

      setsnackbaropen(true);

      setsnackbarmsg(
        "Erreur enregistrement"
      );
    }

    setLoading(false);
  };
  const snackbarClose = () => {
    setsnackbaropen(false);
  };
  return (

    <div>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbaropen}
        autoHideDuration={3000}
        onClose={(snackbarClose) =>
          setsnackbaropen(false)
        }
        message={snackbarmsg}
        action={
          <IconButton
            color="inherit"
            onClick={snackbarClose}
          >
            x
          </IconButton>
        }
      />

      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        centered
        backdrop="static"
      >

        <Modal.Header closeButton>

          <Modal.Title>
            Modifier la Fiche Dossier
          </Modal.Title>

        </Modal.Header>

        <Modal.Body>

          <Card>

            <Card.Body>

              <Row>

                <Col md={4}>
                  <TextField
                    label="Gestion Stock"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={GS}
                    onChange={(e) =>
                      setGS(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <TextField
                    label="Suivi Clientèle"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={SV}
                    onChange={(e) =>
                      setSV(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <TextField
                    label="Multi Magasin"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={GMM}
                    onChange={(e) =>
                      setGMM(
                        e.target.value
                      )
                    }
                  />
                </Col>

              </Row>

              <Row className="mt-2">

                <Col md={4}>
                  <TextField
                    label="Gestion FTT"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={GFTT}
                    onChange={(e) =>
                      setGFTT(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <TextField
                    label="Gestion Achat"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={GA}
                    onChange={(e) =>
                      setGA(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <TextField
                    label="Calcul Import"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={
                      AffCalculImport
                    }
                    onChange={(e) =>
                      setAffCalculImport(
                        e.target.value
                      )
                    }
                  />
                </Col>

              </Row>

              <Row className="mt-2">

                <Col md={4}>
                  <TextField
                    label="Point Vente"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={GPV}
                    onChange={(e) =>
                      setGPV(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <TextField
                    label="Facturation PV"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={fact_pv}
                    onChange={(e) =>
                      setFact_pv(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={4}>
                  <TextField
                    label="Gestion SAV"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={GSAV}
                    onChange={(e) =>
                      setGSAV(
                        e.target.value
                      )
                    }
                  />
                </Col>

              </Row>

              <Row className="mt-2">

                <Col md={6}>
                  <TextField
                    label="Contrôle Stock"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={ctrlstk}
                    onChange={(e) =>
                      setctrlstk(
                        e.target.value
                      )
                    }
                  />
                </Col>

                <Col md={6}>
                  <TextField
                    label="Multi Devise"
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    value={MD}
                    onChange={(e) =>
                      setMD(
                        e.target.value
                      )
                    }
                  />
                </Col>

              </Row>

            </Card.Body>

          </Card>

          <br />

          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={enregistrer}
            disabled={loading}
          >
            {loading
              ? "Enregistrement..."
              : "Enregistrer"}
          </Button>

        </Modal.Body>

      </Modal>

    </div>
  );
};

export default FicheDoss;




// import React, { useEffect, useState } from "react";
// import "./ModulesFabrication.css";

// const FicheDoss = ({ ConfigDossier ,onClose}) => {
//   const [loading, setLoading] = useState(false);

//   const [modules, setModules] = useState([
//     { id: 1, name: "Contrôle du Niveau du Stock", column: "ctrlstk", checked: false },
//     { id: 2, name: "Gestion de Stock", column: "GS", checked: false },
//     { id: 3, name: "Suivi Clientèle", column: "SV", checked: false },
//     { id: 4, name: "Gestion Multi Magasin", column: "GMM", checked: false },

//     { id: 5, name: "Gestion de Ventes", column: "GFTT", checked: false },
//     { id: 6, name: "Gestion d'Achats", column: "GA", checked: false },
//     { id: 7, name: "Bon Entrée Import", column: "AffCalculImport", checked: false },

//     { id: 8, name: "Gestion Point De Vente", column: "GPV", checked: false },
//     { id: 9, name: "Facturation Point de Vente", column: "fact_pv", checked: false },

//     { id: 10, name: "Gestion du SAV", column: "GSAV", checked: false },
//     { id: 11, name: "Gestion Multi Devise", column: "MD", checked: false },
//   ]);

//   // ✅ charger depuis backend
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!ConfigDossier) return;

//       try {
//         const url = `https://www.24-crm.tn/webservice/api/Dossier/GetDossier?coddos=${encodeURIComponent(
//           ConfigDossier.coddos
//         )}&serveur=${encodeURIComponent(
//           ConfigDossier.serveur
//         )}&user=${encodeURIComponent(
//           ConfigDossier.utilisateur
//         )}&pwd=${encodeURIComponent(
//           ConfigDossier.pwd_serveur
//         )}&database=psdossier`;

//         const res = await fetch(url);
//         const data = await res.json();

//         // 🔥 mapping dynamique
//         setModules((prev) =>
//           prev.map((mod) => ({
//             ...mod,
//             checked: data[mod.column] === 1,
//           }))
//         );
//       } catch (error) {
//         console.error("Erreur chargement :", error);
//       }
//     };

//     fetchData();
//   }, [ConfigDossier]);

//   // ✅ changer checkbox
//   const handleChange = (id) => {
//     setModules((prev) =>
//       prev.map((item) =>
//         item.id === id
//           ? { ...item, checked: !item.checked }
//           : item
//       )
//     );
//   };

//   // ✅ API update
//   const updateModule = async (column, value) => {
//     try {
//       const url = `https://www.24-crm.tn/webservice/api/Dossier/SetColumn?column=${column}&value=${Number(
//         value
//       )}&coddos=${encodeURIComponent(
//         ConfigDossier.coddos
//       )}&serveur=${encodeURIComponent(
//         ConfigDossier.serveur
//       )}&user=${encodeURIComponent(
//         ConfigDossier.utilisateur
//       )}&pwd=${encodeURIComponent(
//         ConfigDossier.pwd_serveur
//       )}&database=psdossier`;

//       await fetch(url);
//     } catch (error) {
//       console.error("Erreur API :", error);
//     }
//   };

//   // ✅ submit
//   const handleSubmit = async () => {
//     if (!ConfigDossier) {
//       alert("❌ ConfigDossier manquant");
//       return;
//     }

//     setLoading(true);

//     try {
//       await Promise.all(
//         modules.map((mod) =>
//           updateModule(mod.column, mod.checked)
//         )
//       );

//       alert("✅ Mise à jour réussie");
//     } catch (error) {
//       console.error(error);
//       alert("❌ Erreur");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container">
//       <div className="header">
//       <h2  style={{
//           color: "#001f7f",
//           fontWeight: 600,
//           letterSpacing: "1px",
//         }}>Configuration des Modules</h2>

//         <button onClick={onClose} style={{marginright: "10px",background: "darkred"}}>✕</button>
//          </div>
//       <div className="grid">
//         {modules.map((item) => (
//           <label key={item.id} className="row">
//             <span>{item.name}</span>

//             <input
//               type="checkbox"
//               checked={item.checked}
//               onChange={() => handleChange(item.id)}
//             />
//           </label>
//         ))}
//       </div>

//       <button
//         className="btn"
//         onClick={handleSubmit} // ✅ CORRIGÉ
//         disabled={loading}
//       >
//         {loading ? "Enregistrement..." : "Enregistrer"}
//       </button>
//     </div>
//   );
// };

// export default FicheDoss;






// import React, { useEffect, useState } from "react";
// import "./ModulesFabrication.css";

// const FicheDoss = ({ ConfigDossier ,onClose}) => {
//   const [loading, setLoading] = useState(false);

//   const [modules, setModules] = useState([
//     { id: 1, name: "Contrôle du Niveau du Stock", column: "ctrlstk", checked: false },
//     { id: 2, name: "Gestion de Stock", column: "GS", checked: false },
//     { id: 3, name: "Suivi Clientèle", column: "SV", checked: false },
//     { id: 4, name: "Gestion Multi Magasin", column: "GMM", checked: false },

//     { id: 5, name: "Gestion de Ventes", column: "GFTT", checked: false },
//     { id: 6, name: "Gestion d'Achats", column: "GA", checked: false },
//     { id: 7, name: "Bon Entrée Import", column: "AffCalculImport", checked: false },

//     { id: 8, name: "Gestion Point De Vente", column: "GPV", checked: false },
//     { id: 9, name: "Facturation Point de Vente", column: "fact_pv", checked: false },

//     { id: 10, name: "Gestion du SAV", column: "GSAV", checked: false },
//     { id: 11, name: "Gestion Multi Devise", column: "MD", checked: false },
//   ]);

//   // ✅ charger depuis backend
//   useEffect(() => {
//     const fetchData = async () => {
//       if (!ConfigDossier) return;

//       try {
//         const url = `https://www.24-crm.tn/webservice/api/Dossier/GetDossier?coddos=${encodeURIComponent(
//           ConfigDossier.coddos
//         )}&serveur=${encodeURIComponent(
//           ConfigDossier.serveur
//         )}&user=${encodeURIComponent(
//           ConfigDossier.utilisateur
//         )}&pwd=${encodeURIComponent(
//           ConfigDossier.pwd_serveur
//         )}&database=psdossier`;

//         const res = await fetch(url);
//         const data = await res.json();

//         // 🔥 mapping dynamique
//         setModules((prev) =>
//           prev.map((mod) => ({
//             ...mod,
//             checked: data[mod.column] === 1,
//           }))
//         );
//       } catch (error) {
//         console.error("Erreur chargement :", error);
//       }
//     };

//     fetchData();
//   }, [ConfigDossier]);

//   // ✅ changer checkbox
//   const handleChange = (id) => {
//     setModules((prev) =>
//       prev.map((item) =>
//         item.id === id
//           ? { ...item, checked: !item.checked }
//           : item
//       )
//     );
//   };

//   // ✅ API update
//   const updateModule = async (column, value) => {
//     try {
//       const url = `https://www.24-crm.tn/webservice/api/Dossier/SetColumn?column=${column}&value=${Number(
//         value
//       )}&coddos=${encodeURIComponent(
//         ConfigDossier.coddos
//       )}&serveur=${encodeURIComponent(
//         ConfigDossier.serveur
//       )}&user=${encodeURIComponent(
//         ConfigDossier.utilisateur
//       )}&pwd=${encodeURIComponent(
//         ConfigDossier.pwd_serveur
//       )}&database=psdossier`;

//       await fetch(url);
//     } catch (error) {
//       console.error("Erreur API :", error);
//     }
//   };

//   // ✅ submit
//   const handleSubmit = async () => {
//     if (!ConfigDossier) {
//       alert("❌ ConfigDossier manquant");
//       return;
//     }

//     setLoading(true);

//     try {
//       await Promise.all(
//         modules.map((mod) =>
//           updateModule(mod.column, mod.checked)
//         )
//       );

//       alert("✅ Mise à jour réussie");
//     } catch (error) {
//       console.error(error);
//       alert("❌ Erreur");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="container">
//       <div className="header">
//       <h2  style={{
//           color: "#001f7f",
//           fontWeight: 600,
//           letterSpacing: "1px",
//         }}>Configuration des Modules</h2>

//         <button onClick={onClose} style={{marginright: "10px",background: "darkred"}}>✕</button>
//          </div>
//       <div className="grid">
//         {modules.map((item) => (
//           <label key={item.id} className="row">
//             <span>{item.name}</span>

//             <input
//               type="checkbox"
//               checked={item.checked}
//               onChange={() => handleChange(item.id)}
//             />
//           </label>
//         ))}
//       </div>

//       <button
//         className="btn"
//         onClick={handleSubmit} // ✅ CORRIGÉ
//         disabled={loading}
//       >
//         {loading ? "Enregistrement..." : "Enregistrer"}
//       </button>
//     </div>
//   );
// };

// export default FicheDoss;
